"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.set.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/esnext.set.difference.v2.js");
require("core-js/modules/esnext.set.intersection.v2.js");
require("core-js/modules/esnext.set.is-disjoint-from.v2.js");
require("core-js/modules/esnext.set.is-subset-of.v2.js");
require("core-js/modules/esnext.set.is-superset-of.v2.js");
require("core-js/modules/esnext.set.symmetric-difference.v2.js");
require("core-js/modules/esnext.set.union.v2.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _rmaNumber = require("@/api/rma-number.api");
var _imeiReceive = require("@/api/imei-receive");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      visible: false,
      form: {},
      rules: {
        rmaNumber: {
          required: true,
          message: "Required",
          trigger: "submit"
        }
      },
      rmaNumbers: [],
      imeiReceiveId: null,
      loading: false
    };
  },
  created: function created() {},
  methods: {
    fetchRmaNumber: function fetchRmaNumber() {
      var _arguments = arguments,
        _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var search, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              search = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : "";
              _context.next = 3;
              return _rmaNumber.rmaNumberApi.findAll({
                search: search,
                page: 1,
                limit: 50
              });
            case 3:
              res = _context.sent;
              _this.rmaNumbers = (0, _toConsumableArray2.default)(new Set(res.data.data.map(function (item) {
                return item.rmaNumber;
              })));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    submitData: function submitData() {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var data, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$refs.form.validate();
            case 2:
              _this2.loading = true;
              _context2.prev = 3;
              data = {
                rmaNumber: _this2.form.rmaNumber,
                imeiReceiveId: _this2.imeiReceiveId
              };
              _context2.next = 7;
              return _imeiReceive.imeiReceiveApi.update(data);
            case 7:
              res = _context2.sent;
              _this2.$message.success("Update successfully");
              _this2.visible = false;
            case 10:
              _context2.prev = 10;
              _this2.loading = false;
              return _context2.finish(10);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3,, 10, 13]]);
      }))();
    },
    handleOpen: function handleOpen(imeiReceiveId) {
      this.imeiReceiveId = imeiReceiveId;
      this.visible = true;
      this.form = {
        rmaNumbers: ""
      };
      this.fetchRmaNumber();
    }
  }
};